import { EnumDataModelV2UpgradeStage as Stage } from '../../graphql/types';
import { UpgradeStep } from './types';

const steps: Record<Stage, UpgradeStep> = {
  [Stage.saving_version]: 'migration',
  [Stage.migrating_transactions]: 'migration',
  [Stage.recalculating]: 'recalculation',
};

export function resolveUpgradeStep(stage?: Stage | null): UpgradeStep {
  return stage ? steps[stage] : 'migration';
}
